(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nbd-lens-switcher"] && !Shopify.designMode) return;
  try {
    class NBDLensSwatch extends HTMLElement {
  constructor() {
    super();
    this.handle = this.dataset.handle;
    this.country = window.Shopify?.country || '';
    this.key = `${this.country}:${this.handle}`;
  }

  connectedCallback() {
    if (this.hasAttribute('data-current')) {
      this.update(true);
      return;
    }
    window.NBD.onLoad(() => this.check());
  }

  productUrl(handle) {
    let base = window.Shopify.routes.root || '/';
    return `${base}products/${handle}`;
  }

  update(ok) {
    if (ok) {
      this.removeAttribute('data-hide');
      this.setAttribute('data-show', '');
    } else {
      this.removeAttribute('data-show');
      this.setAttribute('data-hide', '');
    }
  }

  save(ok) {
    this.store.put(this.key, ok);
  }

  async check() {
    this.store = window.NBD.cache('LensSwatch', 512);

    if (this.store.has(this.key)) {
      this.update(this.store.get(this.key));
      return;
    }

    let res = await fetch(this.productUrl(this.handle), { method: 'HEAD' });

    if (res.ok || res.status == 404) {
      this.save(res.ok);
    }

    this.update(res.ok);
  }
}

customElements.define('nbd-lens-swatch', NBDLensSwatch);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nbd-measurements"] && !Shopify.designMode) return;
  try {
    class NBDMeasurementsTable extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      this.toggle = this.querySelector('input[name=toggle]');
      this.toggle?.addEventListener('change', this.handleToggle.bind(this));
      this.cells = this.querySelectorAll('td[data-cm]');
    }

    disconnectedCallback() {
      this.toggle?.removeEventListener('change', this.handleToggle);
    }

    handleToggle(event) {
      this.cells?.forEach(cell => {
        let cm = parseFloat(cell.dataset.cm);
        cell.innerHTML = event.target.checked ? this.toInches(cm) : cm;
      })

    }

    toInches(cm) {
      if (isNaN(cm)) {
        return cm;
      }
      return String(Math.round(cm * 0.3937008 * 2) / 2).replace('.5', ' ½');
    }

  }

  if (!customElements.get('nbd-measurements-table')) {
    customElements.define('nbd-measurements-table', NBDMeasurementsTable);
  }
  } catch(e) { console.error(e); }
})();

})();
